const whatNotToDo = {
  slug: 'what-not-to-do',
  title: 'What not to do when a caller might be a scammer',
  description:
    'Never share OTPs, install unknown apps, send money, or give remote access. Practical rules to protect yourself on scam calls.',
  category: 'scams',
  guideType: 'tips',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['red-flags', 'verify-before-you-trust', 'password-managers'],
  sections: [
    {
      type: 'paragraph',
      text: 'When a call feels wrong, the safest move is to stop engaging. Scammers are skilled at keeping you on the line until you comply.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Do not share secrets',
    },
    {
      type: 'list',
      items: [
        'One-time passwords or authentication codes from SMS or email',
        'Bank card PINs, online banking passwords, or security question answers',
        'National ID, tax, or passport numbers to an unsolicited caller',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Do not install software or grant access',
    },
    {
      type: 'paragraph',
      text: 'Never install apps, browser extensions, or remote-desktop tools at a caller’s direction. That gives them control of your device.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Do not send money on demand',
    },
    {
      type: 'paragraph',
      text: 'Legitimate organizations do not require gift cards, crypto, or urgent wire transfers to resolve a problem discovered on a cold call.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Do not trust caller ID alone',
    },
    {
      type: 'paragraph',
      text: 'The number on your screen can be faked. See our guide on caller ID spoofing.',
    },
    {
      type: 'link',
      to: '/learn/caller-id-spoofing',
      label: 'How caller ID spoofing works',
    },
    {
      type: 'link',
      to: '/learn/password-managers',
      label: 'Protect accounts with unique passwords',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default whatNotToDo;
